import { render } from "./XIconSolidSlidersHorizontal.vue?vue&type=template&id=5bd3a757"
import script from "./XIconSolidSlidersHorizontal.vue?vue&type=script&lang=js"
export * from "./XIconSolidSlidersHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidSlidersHorizontal.vue"]])

export default __exports__